import { Card, IconButton, MenuItem, Modal, Select, Tooltip } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";
import { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import CrudService from 'services/cruds-service'
import ListIcon from '@mui/icons-material/List';
import EditIcon from '@mui/icons-material/Edit'
import ContactDeviceAccessDeviceView from "cruds/common/contactDeviceAccessDeviceView";
import DeleteIcon from "@mui/icons-material/Delete";
import MDButton from "components/MDButton";

const ContactItemAccess = () => {

    const [contactList, setContactList] = useState([])
    const [viewModel, setViewModel] = useState(false)
    const [viewData, setViewData] = useState([])
    const [contactDeviceAccessList, setContactDeviceAccessList] = useState({})
    const [selectedThreRows, setSelectedThreRows] = useState([]);
    const [deviceList, setDeviceList] = useState([]);
    const [openContact, setOpenContact] = useState(false)
    const [tempselectedDevices, setTempSelectedDevices] = useState([])
    const selectedContactId = useRef(null)
    const [tableData, setTableData] = useState([])
    const [contactName, setContactName] = useState('')

    useEffect(() => {
        fetchContactList();
    }, [])

    useEffect(() => {
        let selectedContacts = deviceList.filter((e) => selectedThreRows.includes(e.address_item_id))
        selectedContacts = selectedContacts.map((e, i) => ({
            ...e,
            access_type: contactDeviceAccessList[e.address_item_id]?.access_type ?? 'read',
            service_access_type: contactDeviceAccessList[e.address_item_id]?.service_access_type ?? 'read',
        }))
        setTempSelectedDevices(selectedContacts)
    }, [selectedThreRows])

    async function fetchContactList() {
        try {
            const response = await CrudService.getAllUserListByAccess();
            setContactList(response.data)
        } catch (error) {
            console.error('fetchContactList', error)
            toast.error(error.error)
        }
    }

    function openViewModel(e, data) {
        e.stopPropagation();
        if (data?.rawData) {
            setViewData(data?.rawData)
            setViewModel(true)
        }
    }

    useEffect(() => {
        setTableData(getRows(contactList))
      }, [contactList])

    const getRows = (info) => {
        let updatedInfo = info.map((row) => {

            return {
                type: 'contact_device_access',
                id: row.contact.contact_id,
                contact_name: row.contact.first_name + ' ' + row.contact.last_name,
                total_item_access: row.total_item_access,
                ...row
            }
        })
        return updatedInfo
    }

    const dataTableData = {
        columns: [
            { Header: 'Contact ID', accessor: 'id' },
            { Header: 'Contact Name', accessor: 'contact_name' },
            { Header: 'Total Item Access', accessor: 'total_item_access' },
            {
                Header: 'actions',
                disableSortBy: true,
                accessor: '',
                Cell: (info) => {
                    return (
                        <MDBox display="flex" alignItems="center">
                            <Tooltip title="View List">
                                <IconButton
                                    onClick={(e) =>
                                        openViewModel(e, info.cell.row.original)
                                    }
                                >
                                    <MDTypography>
                                        <ListIcon />
                                    </MDTypography>
                                </IconButton>
                            </Tooltip>
                            <Tooltip title="Edit List">
                                <IconButton
                                    onClick={(e) => clickAccessHandler(e, info.cell.row.original.id)}
                                >
                                    <MDTypography>
                                        <EditIcon />
                                    </MDTypography>
                                </IconButton>
                            </Tooltip>
                        </MDBox>
                    )
                },
            },
        ],

        rows: tableData,
    }

    const getViewRow = (info) => {
        let updatedInfo = info.map((row) => {
            let entity_name = row.EntityAddressItem?.Entity?.name
            entity_name = entity_name != '' ? entity_name : row.EntityAddressItem?.Entity?.first_name + ' ' + row.EntityAddressItem?.Entity?.last_name
            return {
                type: 'contact_item_access',
                id: row.address_item_id,
                access_type: row?.access_type?.toUpperCase(),
                service_access_type: row?.service_access_type?.toUpperCase(),
                name: row.EntityAddressItem.name,
                item_name: row.EntityAddressItem?.Item?.name,
                entity_name: entity_name,
            }
        })
        return updatedInfo
    }

    const dataViewTable = {
        columns: [
            { Header: 'Item ID', accessor: 'id' },
            { Header: 'Name', accessor: 'name' },
            { Header: 'Item Name', accessor: 'item_name' },
            { Header: 'Entity Name', accessor: 'entity_name' },
            { Header: 'Access Type', accessor: 'access_type' },
            { Header: 'Service Access Type', accessor: 'service_access_type' },
        ],

        rows: getViewRow(viewData),
    }

    const clickAccessHandler = async (e, val) => {
        e.stopPropagation();
        try {
            selectedContactId.current = val
            let contact_name = contactList.find(e => e.contact?.contact_id == val)?.contact;
            setContactName(`${contact_name?.first_name} ${contact_name?.last_name}`)
            let response = await CrudService.getUserListByAccess(val)
            if (response.status === 'success') {
                let list = response.data.reduce((acc, val) => {
                    acc[val.address_item_id] = {access_type: val?.access_type, service_access_type: val?.service_access_type}
                    return acc;
                }, {})
                setContactDeviceAccessList(list);
                let addressItemsIds = response.data.map((e) => e.address_item_id)
                setSelectedThreRows(addressItemsIds)
                // let addressItemIds = response.data.map((e) => e.EntityAddressItem)
                setDeviceList(response.available_items)
            }
            setOpenContact(true)
        } catch (error) {
            console.error('Click access handler', error)
        }
    }

    const contactAccessHandler = async () => {
        try {
            let processPayload = tempselectedDevices.map((val) => ({
                contact_id: selectedContactId.current,
                address_item_id: val.address_item_id,
                access_type: val?.access_type,
                service_access_type: val?.service_access_type,
            }))
            let payload = {
                contact_id: selectedContactId.current,
                payload: processPayload
            }

            let resp = await CrudService.upsertContactDeviceAccessIndex(payload)
            if (resp.success) {
                toast.success(resp.msg)
                fetchContactList();
            }
            setOpenContact(false)
        } catch (error) {
            console.error('error', error)
            toast.error(error.error)
        }
    }

    const removeList = (index) => {
        const updatedContactList = [...tempselectedDevices]
        updatedContactList.splice(index, 1)
        setTempSelectedDevices(updatedContactList)
    }
    const handleChange = (index, event) => {
        const { name, value } = event.target;
        const updatedDataTable = [...tempselectedDevices];
        updatedDataTable[index].access_type = value;
        setTempSelectedDevices(updatedDataTable);
    };
    const handleServiceChange = (index, event) => {
        const { name, value } = event.target;
        const updatedDataTable = [...tempselectedDevices];
        updatedDataTable[index].service_access_type = value;
        setTempSelectedDevices(updatedDataTable);
    };

    const getRowsForContact = () => {
        return tempselectedDevices.map((row, index) => {
            const fields = [
                {
                    address_item_id: row?.address_item_id
                },
                {
                    name: row?.name
                },
                {
                    itemName: row?.itemName ?? row?.Item?.name
                },
            ];

            fields.push(
                {
                    access_type: (
                        <Select label="Access Type" name="access_type" value={row.access_type ?? 'read'} onChange={(e) => handleChange(index, e)} sx={{ height: '40px' }} required>
                            <MenuItem key={'read'} value={'read'}>Read</MenuItem>
                            <MenuItem key={'write'} value={'write'}>Write</MenuItem>
                        </Select>
                    ),
                    service_access_type: (
                        <Select label="Service Access Type" name="service_access_type" value={row.service_access_type ?? 'read'} onChange={(e) => handleServiceChange(index, e)} sx={{ height: '40px' }} required>
                            <MenuItem key={'read'} value={'read'}>Read</MenuItem>
                            <MenuItem key={'write'} value={'write'}>Write</MenuItem>
                        </Select>
                    ),
                }
            );
            return Object.assign({}, ...fields);
        });
    };
    const tableThresholdData = {
        columns: [
            { Header: "Address Item ID", accessor: "address_item_id" },
            { Header: "Name", accessor: "name" },
            { Header: "Item Name", accessor: "itemName" },
            { Header: "Access Type", accessor: "access_type" },
            { Header: "Service Access Type", accessor: "service_access_type" },
            {
                Header: "actions",
                disableSortBy: true,
                accessor: "",
                Cell: (info) => {
                    return (
                        <MDBox display="flex" alignItems="center">
                            {(
                                <Tooltip title="Delete Parameter">
                                    <IconButton onClick={() => removeList(info.cell.row.index)}>
                                        <MDTypography><DeleteIcon /></MDTypography>
                                    </IconButton>
                                </Tooltip>
                            )}
                        </MDBox>
                    );
                },
            }
        ],
        rows: getRowsForContact(),
    };

    return <DashboardLayout>
        <DashboardNavbar />
        <MDBox pt={1}>
            <Card>
                <MDBox
                    p={3}
                    lineHeight={1}
                    display="flex"
                    justifyContent="space-between"
                >
                    <MDTypography variant="h5" fontWeight="medium">
                        Contact Item/Request Access
                    </MDTypography>
                    {/* <MDButton
                            variant="gradient"
                            color="dark"
                            size="small"
                            type="submit"
                            onClick={clickAddHandler}
                        >
                            + Add Template
                        </MDButton> */}
                </MDBox>
                {
                    contactList.length ?
                    <DataTable table={dataTableData} canSearch={true} entriesPerPage={{ defaultValue: 100 }} /> : ''
                }
            </Card>
        </MDBox>
        <Modal
            open={viewModel}
            onClose={() => setViewModel(false)}
            aria-labelledby="modal-title"
            aria-describedby="modal-description"
        >
            <Card
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: { xs: '90%', sm: '70%', md: '50%', lg: '40%' }, // Set the desired width here
                    height: { xs: '90%', sm: '90%', md: '700px', lg: '700px' },
                    backgroundColor: 'white',
                    p: 4,
                }}
            >
                <MDTypography variant="h4" component="h2" gutterBottom>
                    View Item Access
                </MDTypography>
                <DataTable table={dataViewTable} canSearch={true} entriesPerPage={{ defaultValue: 100 }} />
            </Card>
        </Modal>
        <Modal
            open={openContact}
            onClose={() => setOpenContact(false)}
            aria-labelledby="modal-title"
            aria-describedby="modal-description"
        >
            <Card
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: '50%', // Set the desired width here
                    backgroundColor: 'white',
                    border: '2px solid #000',
                    boxShadow: 24,
                    p: 4,
                }}
            >
                <ContactDeviceAccessDeviceView contactName={contactName} devices={deviceList} selectedDevices={selectedThreRows} setSelectedDevices={setSelectedThreRows} />
                <DataTable table={tableThresholdData} canSearch={true} tableHeight="calc(100vh - 410px)" />
                <MDBox ml="auto" mt={3} display="flex" justifyContent="flex-end">
                    <MDButton variant="contained" color="secondary" onClick={() => setOpenContact(false)}>
                        Cancel
                    </MDButton>
                    <MDButton variant="contained" color="info" onClick={contactAccessHandler} style={{ marginLeft: '10px' }}>
                        Save
                    </MDButton>
                </MDBox>
            </Card>
        </Modal>
        <Footer />
    </DashboardLayout>

}

export default ContactItemAccess;